import React from 'react';
import { SectionTitle } from 'Components/Titles';
import './ShowsGrid.css';

const GridItem = ({ images, url, name = 'Image', target = '_self' }) => {
  const image = images.seriesList.SD;
  let content = (
    <figure className="gridFigure">
      <img src={image} alt={name} width="100%" height="100%" />
      <figcaption />
    </figure>
  );
  content = url && (
    <a className="showsImageGridItemLink" href={url} target={target}>
      {content}
    </a>
  );

  return <li className="showsImageGridItem">{content}</li>;
};

export const ShowsGrid = ({ headline = '', description = '', shows = [], className = '' }) => {
  if (shows && shows.length > 0) {
    let showsList = shows;

    while (showsList.length < 36) {
      showsList = showsList.concat(showsList);
    }

    return (
      <div className={`showsGrid ${className}`}>
        <div className="showsGridHead">
          <SectionTitle text={headline} align="center" />
          {description && <div className="showsGridDescription">{description}</div>}
        </div>
        <ul className="showsImageGrid">
          {showsList.map((show, index) => (
            <GridItem key={index} {...show} />
          ))}
        </ul>
      </div>
    );
  }
  return <div className="showsGrid" />;
};
